import { DrawerActionsProps } from '../drawer/drawer-actions';
import { Action, IconActionProps, MenuActionItem, TableHeaderAction } from './types';

function menuActionItem<TAction extends MenuActionItem>(action: TAction): TAction {
  return action;
}

function baseAction<TAction extends Action>(action: TAction): TAction {
  return action;
}

function iconAction<TAction extends IconActionProps>(action: TAction): TAction {
  return action;
}

function drawerToolbarActions<TAction extends DrawerActionsProps>(toolbar: TAction): TAction {
  return toolbar;
}

function tableHeaderActionItem<TAction extends TableHeaderAction>(action: TAction): TAction {
  return action;
}

function tableHeaderActions<TAction extends TableHeaderAction>(actions: TAction[]): TAction[] {
  return actions;
}

export const actionHelper = {
  drawerToolbarActions,
  iconAction,
  menuActionItem,
  tableHeaderActionItem,
  /**
   * @primaryAction and @secondaryAction accept the same props but their implementation inside Drawer Actions component is different
   */
  primaryAction: baseAction,
  secondaryAction: baseAction,
  tableHeaderActions,
};
